import styled from 'styled-components';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import { useState } from 'react';
import { ModalCheck } from './modals/modal-check';
import { ModalCancel } from './modals/modal-cancel';
const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  button{
    width: 100%;
    height: 30px;
    border-radius: 3px;
    font-size: 14px;

    &.not-yet{
        border: 1px solid var(--redColor1);
        color: var(--redColor1);
    }

    &.ok{
        border: 1px solid var(--greenColor1);
        color: var(--greenColor1);
    }
  }
`

export function TdInventoryReceive({
    returnExchange
}) {
    const [checkModalOpen, setCheckModalOpen] = useState(false);
    const [cancelModalOpen, setCancelModalOpen] = useState(false);

    return (
        <>
            <StyledTableCell>
                {returnExchange?.inventoryReceivedFlag ?
                    <CustomBlockButton
                        type='button'
                        className='ok'
                        onClick={(e) => { e.stopPropagation(); setCancelModalOpen(true) }}
                    >반영됨</CustomBlockButton>
                    :
                    <CustomBlockButton
                        type='button'
                        className='not-yet'
                        onClick={(e) => { e.stopPropagation(); setCheckModalOpen(true) }}
                    >미반영</CustomBlockButton>
                }
            </StyledTableCell>

            {checkModalOpen && (
                <ModalCheck
                    open={checkModalOpen}
                    onClose={() => setCheckModalOpen(false)}
                    returnExchange={returnExchange}
                />
            )}

            {cancelModalOpen && (
                <ModalCancel
                    open={cancelModalOpen}
                    onClose={() => setCancelModalOpen(false)}
                    returnExchange={returnExchange}
                />
            )}
        </>
    );
}